import {config} from 'config/env/index';

// Firebase web feature flag which already turnned on
export const shopping1PNextDayEnabled = true;
export const weightedFreshPhase3Enabled = true;
export const isEnable3POwnFleet = true;
export const isNewEndPoint = true;

// Doppler flag
export const isBasketDiversifyFlagEnabled = config.ENABLE_BASKET_DIVERSIFY;
export const isEnabledRecommendationMFE = config.ENABLED_BASKET_RECOMMENDATION_MFE;

// Static variable
export const allowAlcohol = true;
export const isPDPRevamp = true;
export const enableBrandDetails = true;
export const shouldFetchDeliveryDescription = true;
export const enableSellInPiece = true;
export const enable1PX = true;
export const webEnableDiscontinuedItem = true;
export const loyaltyProductPDPEnabled = true;

export const isDisabledButAllowedToOrderForAS = false;
export const isRecommendationCarousel = true;
export const showOnlyAddToCartButton = false;
export const AS_HALF_PRODUCT_QUANTITY = 0.5;
export const removeImageSkeleton = false;
export const isShowAddtoCartBtn = true;
export const recommendationVariant = config.RECOMMENDATION_VARIANT;
export const PROMOTION_SUGGESTION_TARGET_UNIT = 'UNIT';
export const PRODUCT_TYPE_1P = '1P';
export const PRODUCT_TYPE_3P = '3P';
export const apiVersion = '?apiVersion=20230109';
export const CURRENCY_CODES = {
  THB: 'THB'
};
export const CONTENT_TYPES = {
  PRODUCT: 'product'
};
export const BASKET_RECOMMENDATION_PAGE_SIZE = 20;

export const SEARCH_PERFORM_TRIGGER_TYPE = {
  SEE_ALL: 'seeAll',
  ENTER: 'enter',
  DIRECT_CLICK: 'directClick',
  HISTORY_CLICK: 'historyClick',
  PLUS_BUTTON: 'plusButton',
  QUANTITY_COUNT: 'quantityCount',
  PRODUCT_CARD: 'productCard',
  SEE_ALL_CARD: 'seeAllCard'
};

export enum CarouselEventMessagesType {
  IFRAME_READY = 'IFRAME_READY',
  NAVIGATE_PDP_PAGE = 'NAVIGATE_PDP_PAGE',
  SEE_ALL = 'SEE_ALL',
  CAROUSEL_EMPTY = 'CAROUSEL_EMPTY'
}

export enum PdpWebviewEvents {
  HANDLE_INCREMENT = 'HANDLE_INCREMENT',
  HANDLE_DECREMENT = 'HANDLE_DECREMENT'
}

export const BASKET_RECOMMENDATION_CAROUSEL_NAME = {
  personalised: 'Recommended for you',
  custom: 'Valued from Bestsellings',
  custom3p: 'Valued From Top Sellers'
};

export const PRODUCT_CARD_CONSTANTS = {
  IMAGE_SCALE_FACTOR: 0.75
} as const;
